import { useState } from "react";
import TableFull from "./table-full";
import TableSummarized from "./table-summarized";
import DialogExport from "./dialog-export";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

export const LONGTERM_STATUS = new Map([
  ["AB", "Aberto"],
  ["CA", "Cancelado"],
  ["LQ", "Liquidado"],
  ["LS", "Liquidado Substituído"],
]);

export default function TableView({
  data,
  totalRegistros,
  page,
  sizePerPage,
  onTableChange,
  viewType,
}) {
  const [openExportBoletos, setOpenExportBoletos] = useState(false);
  const [selectedTitles, setSelectedTitles] = useState([]);
  const snackbar = useSnackbar();

  const handleBoletoUnavailable = () => {
    snackbar.showMessage(
      "Este boleto ainda não está disponível para download.",
      { severity: "info" },
    );
  };

  const handleExportBoletos = (selectedRows) => {
    setOpenExportBoletos(true);
    setSelectedTitles(selectedRows);
  };

  return (
    <>
      {viewType === "full" ? (
        <TableFull
          data={data}
          onExportBoletos={handleExportBoletos}
          onBoletoUnavailable={handleBoletoUnavailable}
          totalRegistros={totalRegistros}
          page={page}
          sizePerPage={sizePerPage}
          onTableChange={onTableChange}
        />
      ) : (
        <TableSummarized
          data={data}
          onBoletoUnavailable={handleBoletoUnavailable}
          onExportBoletos={handleExportBoletos}
          totalRegistros={totalRegistros}
          page={page}
          sizePerPage={sizePerPage}
          onTableChange={onTableChange}
        />
      )}
      {openExportBoletos && (
        <DialogExport
          onClose={() => setOpenExportBoletos(false)}
          titles={selectedTitles}
        />
      )}
    </>
  );
}
